<template>
    <div class="home">
        <div id="pano" ref="pano"></div>
        <div v-if='isStart' class='splash'>
            <div class='bg' :style="{'background-image': `url(${main_bg})`}"></div>
            <!-- <div class='logo' :style="{'background-image': `url(${main_logo})`}"></div>
            <div class='slogan' :style="{'background-image': `url(${main_slogan})`}"></div>
            <div v-if='showStartBtn' class='startBtn' :style="{'background-image': `url(${main_btn})`}" @click='onStartVr()'></div> -->

            <img class='logo' :src='main_logo' />
            <img class='slogan' :src='main_slogan' />
            <img v-if='showStartBtn' class='startBtn' :src='main_btn' @click='onStartVr()' />

            <!-- <b-btn v-if='showStartBtn' class='nuSkinBtn startBtn' :style="{'background-image': `url(${main_btn})`}" @click='onStartVr()'>시작하기</b-btn> -->
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

import { mapState, mapActions } from "vuex";

import main_bg from '@/assets/img/main_bg.jpg';
import main_logo from '@/assets/img/main_logo.png';
import main_slogan from '@/assets/img/main_text.png';
import main_btn from '@/assets/img/main_btn.png';

export default {
    name: "Home_vr",
    components: {
    },
    data() {
        return {
            main_bg,
            main_logo,
            main_slogan,
            main_btn,
            showStartBtn: false,
            isStart: true,
            isMobile: false,
            showTraningModal: false,
            shownTraningModal: false,
            showTraningDetailModal: false,
            krpano: null,
            gyroIsAvailable: false,
            isActiveGyro: false,
            sidebar: {
                main: false,
                center: false,
                service: false,
            },
            eventFilter: {
                area: [
                    { title: "서울", state: false },
                    { title: "부천", state: false },
                    { title: "대구경북", state: false },
                    { title: "광주", state: false },
                    { title: "부산", state: false },
                    { title: "본사", state: false },
                ],
                title: "",
            },
            traningData: null,
        };
    },
    created() {},
    mounted() {
        window.addEventListener("resize", this.onResize);
        this.onResize();

        let swfPath =
            process.env.NODE_ENV === "production"
                ? process.env.VUE_APP_PRODUCTION_CDN + "/assets/vtour/tour.swf"
                : "assets/vtour/tour.swf";
        let xmlPath =
            process.env.NODE_ENV === "production"
                ? process.env.VUE_APP_PRODUCTION_CDN + "/assets/vtour/tour.xml"
                : "assets/vtour/tour.xml";
        embedpano({
            swf: swfPath,
            xml: xmlPath,
            target: "pano",
            id: "vr",
            html5: "auto",
            mobilescale: 1.0,
            initvars: { editor: 0 },
            passQueryParameters: true,
            onready: this.onReadyKrpano,
        });

    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    computed: {
        btnStates() {
            return this.eventFilter.area.map((btn) => btn.state);
        },
    },
    methods: {
        onResize(event) {
            this.isMobile = window.innerWidth <= 768 ? true : false;
        },
        onReadyKrpano(krpano) {
            this.krpano = krpano;
        },
        // main.xml 의 onnewpano에서 실행.
        onKrpanoStartup() {
            // 쿼리로 로딩 파노 설정
            if (this.$route.query.startScene) {
                this.krpano.call(`loadscene(${this.$route.query.startScene})`);
                this.isStart = false;
            }
            this.showStartBtn = true;
        },
        onKrpanoGyroOn() {
            this.gyroIsAvailable = this.krpano.get(
                "plugin[skin_gyro].isavailable"
            );
            if (this.krpano.get("plugin[skin_gyro].enabled")) {
                this.isActiveGyro = true;
            } else {
                this.isActiveGyro = false;
            }
        },
        // main.xml 의 onnewpano에서 실행.
        checkCurrentPano() {
            this.setCurrentScene(this.krpano.get("xml.scene"));
        },
        loadLocalStoragedItem(itemKey) {
            this.isLocalStorageAvailable = this.$localStorage.available(
                "localStorage"
            );
            if (this.isLocalStorageAvailable) {
                return this.$localStorage.getData(itemKey);
            } else {
                console.error(
                    "localstorage 가 불가능합니다. 일부 기능이 정상작동 하지 않습니다."
                );
            }
            return null;
        },
        
        onClicSideMenu(type) {
            this.sidebar.main = false;

            if (type == "center") {
                this.sidebar.service = false;
                this.sidebar.center = true;
            } else if (type == "service") {
                this.sidebar.center = false;
                this.sidebar.service = true;
            } else {
                console.error("onClicSideMenu unexpected type", type);
            }
        },
        onClickLinkBranch(param1, param2) {
            linkBranch(param1, param2);
        },
        onClickOpenUrl(url) {
            window.open(url);
        },

        onStartVr(){
            this.isStart = false;
            this.krpano.call('webvr.enterVR()');
            this.krpano.call('start_bgm()');
        },
    },
};
</script>

<style scoped>
.home,
#pano {
    width: 100%;
    height: 100%;
}
.home {
    position: relative;
}

.only-pc {
    display: none;
}
@media screen and (min-width: 960px) {
    .only-pc {
        display: block;
    }
}

.nuSkinBtn,
.nuSkinBtn:focus,
.nuSkinBtn:active {
    background-color: #651fbb;
    position: absolute;
}
.nuSkinBtn:hover {
    background-color: #440099 !important;
    border-color: #440099 !important;
}
.nuSkinBtn.nuSkinLightBtn,
.nuSkinBtn.nuSkinLightBtn:focus,
.nuSkinBtn.nuSkinLightBtn:active {
    background-color: #8257b6;
    position: absolute;
}
.nuSkinBtn.nuSkinLightBtn:hover {
    background-color: #651fbb !important;
    border-color: #651fbb !important;
}
.nuSkinBtnWrap {
    position: absolute;
}
.nuSkinBtnWrap.toggleGyro {
    top: 4em;
    /* top: 10em; */
    right: 1em;
}
.nuSkinBtnWrap.toggleGyro > .nuSkinBtn,
.nuSkinBtnWrap.toggleGyro > .nuSkinBtn:hover {
    position: initial;
    background-color: #8257b6;
}
.nuSkinBtnWrap.toggleGyro > .nuSkinBtn.active {
    background-color: #440099;
}
.nuSkinBtnWrap.toggleGyro > .nuSkinBtn.deactive {
    background-color: #6b6b6b !important;
}

.nuSkinBtn > .mdi {
    margin-right: 0.5em;
}
.nuSkinBtn > .mdi.mdi-menu {
    margin-right: 0;
}
.goPromotion {
    top: 7em;
    left: 1em;
}
.goBackBtn {
    top: 1em;
    left: 1em;
}
.goMall {
    top: 4em;
    left: 1em;
}
.menuBtn {
    top: 1em;
    right: 1em;
}
#modal-xl___BV_modal_outer_ >>> a {
    color: #000 !important;
}
#modal-xl___BV_modal_outer_ >>> .modal-xl {
    max-width: 95%;
}
#modal-xl___BV_modal_outer_ >>> .fc-header-toolbar {
    display: block;
}
@media screen and (min-width: 960px) {
    #modal-xl___BV_modal_outer_ >>> .fc-header-toolbar {
        display: inherit;
    }
}

.splash{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #fff;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.splash .bg{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-position: center;
    background-size: cover;
}
.splash .logo{
    height: 15vh;
    margin-bottom: 8vh;
    z-index: 1;
}
.splash .slogan{
    height: 18vh;
    margin-bottom: 5vh;
    z-index: 1;
}
.splash .startBtn{
    height: 15vh;
    z-index: 1;
}
/* .splash .logo{
    width: 20%;
    height: 20%;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    margin-bottom: 2.5rem;
    z-index: 1;
}
.splash .slogan{
    width: 20%;
    height: 20%;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    margin-bottom: 2.5rem;
    z-index: 1;
}
.splash .startBtn{
    //position: relative;
    //background: transparent;
    //margin-top: 1rem;
    //z-index: 1;

    width: 40%;
    height: 20%;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    z-index: 1;
} */
</style>